<template>
    <div v-if="loaded" class="container white-page-container d-flex align-items-center justify-content-center">
        <div v-if="success">
            <h4 class="text-center thanks-text" v-if="approval">Merci !</h4>

            <div class="text-center mt-6">
                <img class="ot-logo" :src="otLogo" alt="logo de l'office de tourisme">
            </div>

            <div v-html="message" class="text-center mt-6 text-black font-weight-bold"></div>
        </div>

        <div v-else-if="!success && code === 'ALREADY_ANSWERED'">
            <div class="text-center mt-6">
                <img class="ot-logo" :src="otLogo" alt="logo de l'office de tourisme">
            </div>
            <h4 class="text-center mt-6 information-text">Vous avez déjà répondu à cette sollicitation</h4>
        </div>

        <div v-else-if="!success && code === 'NOT_FOUND'">
            <h4 class="text-center mt-6 information-text">Cette sollicitation n'existe plus</h4>
        </div>
    </div>
</template>

<script>
export default {
    name: "WhitePage",
    data() {
        return {
            providerDataDiffId: null,
            approval: true,
            otLogo: null,
            success: true,
            code: null,
            loaded: false,
            message: null,
        }
    },
    methods: {
        getLogo() {
            this.$http.get("veille-tourisme/account-logo/" + this.providerDataDiffId).then((res) => {
                this.otLogo = res.body.data.logo
            })
        },
        getMessage() {
            this.$http.get("veille-tourisme/account-vt-message/" + this.providerDataDiffId).then((res) => {
                this.message = res.body.data.message
            })
        },
        acceptDiffs() {
            this.$http.put("veille-tourisme/accept", { "id": this.providerDataDiffId }).then((res) => {
                this.success = res.body.success
                this.code = res.body.code

                if (this.success) {
                    this.getLogo()
                    this.getMessage()
                }

                this.loaded = true
            })
        },
        refuseDiffs() {
            this.$http.put("veille-tourisme/refuse", { "id": this.providerDataDiffId }).then((res) => {
                this.success = res.body.success
                this.code = res.body.code

                if (this.success) {
                    this.getLogo()
                    this.getMessage()
                }

                this.loaded = true
            })
        },
    },
    created() {
        window.Intercom("shutdown")
        window.Intercom("hide")

        this.providerDataDiffId = atob(this.$route.params.providerDataDiffId)

        if (this.$route.fullPath.includes("denial")) {
            this.approval = false
        }

        if (this.approval) {
            this.acceptDiffs()
        } else {
            this.refuseDiffs()
        }
    },
}
</script>